import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { usePlaybackJumpNavigation } from '../hooks/usePlaybackJumpNavigation';

const JumpBackward = () => {
  const { onJumpBackward, isJumpBackwardDisabled } = usePlaybackJumpNavigation();

  return (
    <PlayerTimelineButton
      tooltipTitle="Skip 5s back"
      buttonId="jump-backward-button"
      onClick={onJumpBackward}
      isDisabled={isJumpBackwardDisabled}
      iconName="IconPlayerSkipBack"
    />
  );
};

export default memo(JumpBackward);
